var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootstrap5LogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 114 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5432 12.1048C12.33 5.95421 17.1292 0.282593 23.6162 0.282593H90.0986C96.5856 0.282593 101.385 5.95421 101.172 12.1048C100.965 18.0136 101.232 25.6652 103.161 31.9066C105.098 38.1658 108.36 42.1235 113.706 42.6313V48.396C108.36 48.9038 105.098 52.8615 103.161 59.1207C101.232 65.3621 100.965 73.0137 101.172 78.9226C101.385 85.0731 96.5856 90.7447 90.0986 90.7447H23.6162C17.1292 90.7447 12.33 85.0731 12.5432 78.9226C12.7497 73.0137 12.481 65.3621 10.5533 59.1207C8.61677 52.8615 5.34551 48.9038 0 48.396V42.6313C5.34551 42.1235 8.61677 38.1658 10.5533 31.9066C12.481 25.6652 12.7497 18.0136 12.5432 12.1048V12.1048Z",
    fill: "url(#paint0_linear_66_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0133 56.3359C76.0133 64.8512 69.7198 70.0138 59.2747 70.0138H39.5771V21.6417H59.1732C67.8825 21.6417 73.5975 26.4009 73.5975 33.708C73.5975 38.8372 69.7551 43.4315 64.855 44.234V44.5037C71.5239 45.2415 76.0133 49.9004 76.0133 56.3359V56.3359ZM47.1978 63.8793V47.9566H57.2674C64.4796 47.9566 68.2226 50.6382 68.2226 55.8678C68.2226 61.0973 64.5834 63.8793 57.7113 63.8793H47.1978ZM47.1978 27.7763H57.3359C62.8477 27.7763 65.9768 30.2573 65.9768 34.749C65.9768 39.5416 62.3376 42.2233 55.7371 42.2233H47.1978V27.7763V27.7763Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_2",
    x1: 16.8782,
    y1: 2.4998,
    x2: 116.024,
    y2: 81.3678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9013FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6610F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white",
    transform: "translate(0 0.390625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap5LogoIcon);
export default __webpack_public_path__ + "static/media/bootstrap-5-logo-icon.37d097d9e1da361f1669f687b3cc56ba.svg";
export { ForwardRef as ReactComponent };